import DashboardIncidentsMainCriticalActions from './DashboardIncidentsMainCriticalActions';

export default DashboardIncidentsMainCriticalActions;
